import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { FIELD_OPS_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { InstituteSubmissionDetailPage } from '@/features/instituteSubmissions/pages/InstituteSubmissionDetailPage';

export const Route = createFileRoute('/_auth/settings/institute-submissions/$submissionId')({
  beforeLoad: () => requirePermission(FIELD_OPS_PERMISSIONS.INSTITUTE_SUBMISSION_VIEW),
  parseParams: ({ submissionId }) => {
    const parsedId = Number(submissionId);
    if (!Number.isInteger(parsedId) || parsedId <= 0) throw notFound();
    return { submissionId: parsedId };
  },
  component: function InstituteSubmissionDetailRoute() {
    const { submissionId } = Route.useParams();
    return (
      <ErrorBoundary moduleName="Institute Submission">
        <Suspense fallback={<PageLoader />}>
          <InstituteSubmissionDetailPage submissionId={submissionId} />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
